import React from 'react';
import { tl } from '../../utils/aracHasar';

/*
  Araç kimliği alanları: model yılı → marka → paket (TSB Kasko Değer
  Listesi'nden) ya da elle yazım. Hesap formunun 1. bölümündeki ızgaraya
  hücre olarak girer; altındaki kasko değeri satırı ayrı (TsbBilgi).
*/
export const AracSecimAlanlari = ({ f, set, tsb }) => {
  if (tsb.elle) {
    return (
      <>
        <label className="ah-alan"><span>Model yılı</span>
          <input className="ah-inp" inputMode="numeric" value={f.modelYili} placeholder="ör. 2013"
            onChange={(e) => set('modelYili', e.target.value.replace(/\D/g, '').slice(0, 4))} /></label>
        <label className="ah-alan"><span>Marka</span>
          <input className="ah-inp" value={f.marka} placeholder="ör. Hyundai"
            onChange={(e) => set('marka', e.target.value)} /></label>
        <label className="ah-alan ah-genis"><span>Model / paket</span>
          <input className="ah-inp" value={f.model} placeholder="ör. Elantra 1.6 D-CVVT Mode Plus"
            onChange={(e) => set('model', e.target.value)} /></label>
      </>
    );
  }

  const yuklenen = (n) => (tsb.yukleniyor === n ? ' (yükleniyor…)' : '');
  return (
    <>
      <label className="ah-alan"><span>Model yılı</span>
        <select className="ah-inp" value={tsb.yilListede ? f.modelYili : ''} onChange={(e) => tsb.yilSec(e.target.value)}>
          <option value="">{tsb.yillar.length ? 'Seçin' : 'Yükleniyor…'}</option>
          {tsb.yillar.map((y) => <option key={y} value={y}>{y}</option>)}
          {tsb.yillar.length > 0 && <option value="eski">Daha eski (elle yaz)</option>}
        </select></label>
      <label className="ah-alan"><span>Marka{yuklenen('marka')}</span>
        <select className="ah-inp" value={f.tsbMarkaId || ''} disabled={!tsb.yilListede}
          onChange={(e) => tsb.markaSec(e.target.value)}>
          <option value="">{tsb.yilListede ? 'Seçin' : 'Önce model yılı'}</option>
          {tsb.markalar.map((m) => <option key={m.id} value={m.id}>{m.ad}</option>)}
        </select></label>
      <div className="ah-alan ah-genis">
        <span>Model / paket{yuklenen('model')}</span>
        <div className="ah-paket">
          {/* Süzgeç doluysa (ruhsattan geldiyse) paket sayısı az olsa da görünür: temizlenebilsin. */}
          {(tsb.tumModelSayisi > 8 || tsb.paketFiltre) && (
            <div className="ah-paket-suzgec">
              <input className="ah-inp ah-paket-ara" value={tsb.paketFiltre} placeholder="Paket ara (ör. mode plus)"
                aria-label="Paket ara" onChange={(e) => tsb.setPaketFiltre(e.target.value)} />
              {tsb.paketFiltre && (
                <button type="button" className="ah-bag" onClick={() => tsb.setPaketFiltre('')}>Temizle</button>
              )}
            </div>
          )}
          {tsb.suzgecUymadi && <span className="ah-not ah-uyari-metin">Aramaya uyan paket yok; bütün paketler gösteriliyor.</span>}
          <select className="ah-inp" value={f.tsbModelId || ''} disabled={!f.tsbMarkaId}
            aria-label="Model / paket" onChange={(e) => tsb.modelSec(e.target.value)}>
            <option value="">
              {!f.tsbMarkaId ? 'Önce marka' : tsb.modeller.length ? `Seçin (${tsb.modeller.length})` : 'Paket listesi boş'}
            </option>
            {tsb.modeller.map((m) => <option key={m.id} value={m.id}>{m.ad}</option>)}
          </select>
        </div>
      </div>
    </>
  );
};

/** Ruhsattaki/elle yazılan araç TSB listesinde değilse ya da seçildiyse kasko değeri satırı. */
export const TsbBilgi = ({ f, tsb }) => {
  const d = tsb.deger;
  return (
    <div className="ah-tsb">
      {tsb.elle ? (
        <p className="ah-not">
          {tsb.listeYok
            ? 'TSB kasko listesine şu an ulaşılamadı; araç bilgilerini elle yazın.'
            : 'Araç elle yazılıyor. TSB kasko listesi son 15 model yılını kapsar.'}
          {!tsb.listeYok && (
            <> <button type="button" className="ah-bag" onClick={() => tsb.elleYaz(false)}>TSB listesinden seç</button></>
          )}
        </p>
      ) : (
        <>
          {tsb.yukleniyor === 'deger' && <p className="ah-not">TSB kasko değeri getiriliyor…</p>}
          {d && tsb.yukleniyor !== 'deger' && (
            <div className="ah-tsb-deger">
              <span className="ah-tsb-etiket">TSB kasko değeri</span>
              {d.kazaAyi && <span><b>{tl(d.kazaAyi.tutar)} TL</b> <small>({d.kazaAyi.ay} listesi{f.kazaTarihi ? ', kaza ayı' : ''})</small></span>}
              {d.guncel && (!d.kazaAyi || d.guncel.ay !== d.kazaAyi.ay) && (
                <span><b>{tl(d.guncel.tutar)} TL</b> <small>(güncel liste{d.guncel.ay ? `, ${d.guncel.ay}` : ''})</small></span>
              )}
            </div>
          )}
          {d?.not && <p className="ah-not ah-uyari-metin">{d.not}</p>}
          {d && <p className="ah-not">Kasko değeri ikinci el piyasa değeri değildir (Yargıtay); yalnız eski formülle karşılaştırma için 6. bölüme yazıldı.</p>}
          <button type="button" className="ah-bag" onClick={() => tsb.elleYaz(true)}>Listede yok, elle yazacağım</button>
        </>
      )}
    </div>
  );
};
